import Vue from 'vue';
import _ from 'lodash';
import axios from 'axios';
import * as CONFIG from '../config/index';

export function notifyError(reason, refs) {
  let errCodes = [];
  if (reason.response && reason.response.data) {
    let arrElementErr = document.getElementsByClassName('validation-error');
    if (arrElementErr) {
      arrElementErr.forEach(v => {
        v.innerHTML = '';
      });
    }
    let errData = reason.response.data;
    if (errData.message) {
      errData.message.forEach(v => {
        errCodes.push(v.code);
        let ref = refs ? refs[`err_${v.code}`] : undefined;
        if (ref) {
          ref.innerHTML = v.msg;
        } else {
          errMsg(v.msg, v.code);
        }
      });
    }
  } else {
    errMsg(reason);
  }
  return errCodes;
}

export function errMsg(msg, header) {
  Vue.notify({
    group: 'notify',
    title: header ? header.toUpperCase() : 'Error',
    text: msg,
    type: 'warn'
  });
  /*VueOnToast.ToastService.pop(
    'error',
    'Error',
    msg
  );*/
}

export function successMsg(msg) {
  Vue.notify({
    group: 'notify',
    title: 'Success',
    text: msg,
    type: 'success'
  });
}

export function mergeArray(arr1, arr2, prop, sortProps) {
  let merge = _.merge(_.keyBy(arr1, prop), _.keyBy(arr2, prop));
  let values = _.values(merge);
  if (sortProps) {
    values = _.orderBy(values, 'sortProps', 'asc');
  }
  return values;
}

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function checkPermission(objectTypeCode, permissionTypeCode) {
  let result = false;
  let permissions = window.localStorage.getItem('permissions')
    ? JSON.parse(window.localStorage.getItem('permissions'))
    : [];
  if (!result) {
    if (permissions && permissions.length > 0) {
      let obj = permissions.find(
        o =>
          o['objectTypeCode'] === objectTypeCode &&
          o['permissionTypeCode'] === permissionTypeCode
      );
      result = !!obj;
    } else {
      result = false;
    }
  }
  return result;
}

export function checkDisplayParentMenu(item) {
  if (item.children) {
    let count = 0;
    item.children.forEach(v => {
      if (v.show === true || typeof v.show === 'undefined') {
        count++;
      }
    });
    return count > 0;
  } else {
    return true;
  }
}

export async function verifyToken(token) {
  try {
    let res = await axios.get(`${CONFIG.API_URL}/auth/verify?token=${token}`);
    return res.data.success === true;
  } catch (e) {
    return false;
  }
}

export async function processCrowdToken() {
  let crowdToken = Vue.$cookies.get('crowd.token_key');
  let crowdTokenOld = Vue.$cookies.get('crowd.token_key.old');
  let result = false;
  if (crowdToken !== crowdTokenOld) {
    try {
      let res = await axios.get(
        `${CONFIG.API_URL}/process-login/crowd?crowdToken=${crowdToken}`
      );
      let resData = res.data;
      if (resData.data) {
        this.$cookies.set(
          'username',
          resData.data.username,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'accessToken',
          resData.data.token,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'roles',
          resData.data.roles,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'crowd.token_key.old',
          crowdToken,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'fsuBuAdmin',
          resData.data.fsuBuAdmin,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'accountCustomerAdmin',
          resData.data.accountCustomerAdmin,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'roleFsuBuDeptCode',
          resData.data.roleFsuBuDeptCode,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'userEmail',
          resData.data.userEmail,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'globalRoles',
          resData.data.globalRoles,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        this.$cookies.set(
          'company',
          resData.data.company,
          CONFIG.COOKIES_EXPIRED_TIME
        );
        window.localStorage.setItem(
          'permissions',
          JSON.stringify(resData.data.permissions)
        );
        axios.defaults.headers.common['Authorization'] =
          'Bearer ' + resData.data.token;
        result = true;
      }
    } catch (e) {
      console.error(e);
    }
  } else {
    result = true;
  }
  return result;
}

export function processCrowdTokenAsync() {
  let crowdToken = Vue.$cookies.get('crowd.token_key');
  let crowdTokenOld = Vue.$cookies.get('crowd.token_key.old');
  if (crowdToken !== crowdTokenOld) {
    return axios.get(
      `${CONFIG.API_URL}/process-login/crowd?crowdToken=${crowdToken}`
    );
  }
}

export async function checkToken() {
  let check = Vue.$cookies.isKey('accessToken');
  if (check) {
    let accessToken = Vue.$cookies.get('accessToken');
    check = await verifyToken(accessToken);
  }
  return check;
}

export async function checkLogin(next, objectTypeCode) {
  let check = await checkToken();
  //debugger;
  if (check) {
    if (objectTypeCode) {
      check = checkPermission(objectTypeCode, 'VIEW');
      if (!check) {
        next('/forbidden');
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    window.location.href = `${CONFIG.LOGIN_URL}`;
  }
}

export function checkPermissionFsuBu(fsuBu) {
  let check = false;
  let roles = Vue.$cookies.get('roles');
  let roleFsuBuDeptCode = Vue.$cookies.get('roleFsuBuDeptCode');
  if (roles) {
    let arrRoles = roles.split(',');
    if (
      arrRoles.includes(CONFIG.SYSTEM_ROLES.SUPER_ADMIN) ||
      arrRoles.includes(CONFIG.SYSTEM_ROLES.ADMIN) ||
      arrRoles.includes(CONFIG.SYSTEM_ROLES.BOV)
    ) {
      check = true;
    }
  }
  if (!check && roleFsuBuDeptCode) {
    let arrRoleFsuBu = roleFsuBuDeptCode.split(',');
    check = arrRoleFsuBu.includes(fsuBu);
  }
  return check;
}

export function getMedalName(code) {
  if (code === 'gold') {
    return 'Vàng';
  } else if (code === 'silver') {
    return 'Bạc';
  } else if (code === 'bronze') {
    return 'Đồng';
  } else if (code === 'consolation') {
    return 'Khuyến khích';
  } else {
    return '';
  }
}

export function getUserRole() {
  const result = {};
  let roles = Vue.$cookies.get('roles');
  if (roles) {
    let arr = roles.toString().split(',');
    arr.forEach(v => {
      let key = v.toLowerCase();
      result[key] = true;
    });
  }
  return result;
}

export function sortArr(arr, keys, sortTypes) {
  return _.sortBy(arr, keys, sortTypes);
}

export function breakLine(content) {
  let result = '';
  if (content) {
    result = content.replace(/(?:\\[rn]|[\r\n]+)+/g, '<br/>');
  }
  return result;
}

export function checkReviewSubmit() {
  //debugger;
  const keys = Object.keys(getUserRole());
  const userRoles = getUserRole();
  const company = Vue.$cookies.get('company');
  let check = false;
  if (userRoles['coordinator'] && company && company.length > 0) {
    check = true;
  } else {
    if (keys.length === 1) {
      check = !userRoles['coordinator']
        ? checkPermission(CONFIG.SCREEN_CODE.REVIEW_SUBMISSION, 'VIEW')
        : checkPermission(CONFIG.SCREEN_CODE.REVIEW_SUBMISSION, 'VIEW') &&
          Vue.$cookies.get('globalRoles') !== 'true';
    } else {
      check = userRoles['system_admin'];
    }
  }
  return check;
}

export default {
  arrayObjectToArrayProps: function(obj, prop) {
    let arr = [];
    if (obj) {
      if (!Array.isArray(obj)) {
        obj = [obj];
      }
      obj.forEach(v => {
        if (v) {
          arr.push(v[prop]);
        }
      });
    }
    return arr;
  },
  notifyError: notifyError,
  errMsg: errMsg,
  successMsg: successMsg,
  mergeArray: mergeArray,
  checkPermission: checkPermission,
  sleep: sleep,
  verifyToken: verifyToken,
  processCrowdToken: processCrowdToken,
  checkLogin: checkLogin,
  checkToken: checkToken,
  checkPermissionFsuBu: checkPermissionFsuBu,
  getMedalName: getMedalName,
  getUserRole: getUserRole,
  sortArr: sortArr,
  breakLine: breakLine,
  checkReviewSubmit: checkReviewSubmit
};



// WEBPACK FOOTER //
// ./src/common/helper.js